import { render, staticRenderFns } from "./PurchasePopup.vue?vue&type=template&id=13ff47ff&"
import script from "./PurchasePopup.vue?vue&type=script&lang=js&"
export * from "./PurchasePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports